import React from 'react';
import { Link } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { message, notification } from 'antd';
import useFetchApiData from '../helper/useFetchApiData';
import { useNavigate } from 'react-router-dom';

const Registration = () => {
    const navigate=useNavigate()
    // Yup Validation Schema
    const validationSchema = Yup.object({
        f_name: Yup.string().required('First name is required'),
        l_name: Yup.string().required('Last name is required'),
        email: Yup.string()
            .email('Must be a valid email')
            .required('Email is required'),
        phone: Yup.string()
            .matches(/^\d{10,15}$/, 'Phone number must be of 10 digits')
            .required('Phone number is required'),
         
    });
    
    // Formik Hook
    const formik = useFormik({
        initialValues: {
            f_name: '',
            l_name: '',
            email: '',
            phone: '',
            
        },
        validationSchema,
        onSubmit: (values) => {
            console.log(values);
            values.phone="+977"+values.phone
            values.name=values.f_name+" "+values.l_name
            values.password="Horse$Piano!Lemon@Galaxy&7Rocket"
            notification.warning({
                message: 'Registering the User , Please Wait !',
                description: 'We are registering you to Gharbar , Please sit back and wait!',
                placement: 'topRight',
            });
            axios
                .post(`${process.env.REACT_APP_BACKEND_URI}/auth/registration`, values)
                .then((response) => {
                    axios.post(`${process.env.REACT_APP_BACKEND_URI}/auth/forgot-password`,
                        {email_or_phone:values.email,
                        type:"email",
                        }).then((response)=>{
                            localStorage.setItem("verification_email",values.email)
                            navigate('/verify-otp')
                        }).catch((error)=>{
                            console.log(error)
                            message.error("Something went wrong")
                        })
                     
                     
                })
                .catch((error) => {
                    console.log(error)
                    notification.error({
                        message: 'The User Already exist',
                        description: 'The user already exist , please try again with new email address.',
                        placement: 'topRight',
                    });
                });
        },
    });

    return (
        <section className="account w-100">
            <div className="container-lg">
                <form onSubmit={formik.handleSubmit}>
                <div className="row gy-4 justify-content-center">
                <div className="col-xl-9 mx-auto my-40">
                            <div className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-40">
                                <h6 className="text-xl mb-32">Register with Gharbar</h6>
                                <div className="row">
                                    {/* First Name */}
                                    <div className="col-md-6 mb-24">
                                        <label htmlFor="f_name" className="text-neutral-900 text-lg mb-8 fw-medium">
                                            First Name <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="common-input"
                                            id="f_name"
                                            placeholder="Enter First Name"
                                            {...formik.getFieldProps('f_name')}
                                        />
                                        {formik.touched.f_name && formik.errors.f_name && (
                                            <div className="text-danger">{formik.errors.f_name}</div>
                                        )}
                                    </div>

                                    {/* Last Name */}
                                    <div className="col-md-6 mb-24">
                                        <label htmlFor="l_name" className="text-neutral-900 text-lg mb-8 fw-medium">
                                            Last Name <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="common-input"
                                            id="l_name"
                                            placeholder="Enter Last Name"
                                            {...formik.getFieldProps('l_name')}
                                        />
                                        {formik.touched.l_name && formik.errors.l_name && (
                                            <div className="text-danger">{formik.errors.l_name}</div>
                                        )}
                                    </div>

                                    {/* Email */}
                                    <div className="col-md-6 mb-24">
                                        <label htmlFor="email" className="text-neutral-900 text-lg mb-8 fw-medium">
                                            Email Address <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="email"
                                            className="common-input"
                                            id="email"
                                            placeholder="Enter Email Address"
                                            {...formik.getFieldProps('email')}
                                        />
                                        {formik.touched.email && formik.errors.email && (
                                            <div className="text-danger">{formik.errors.email}</div>
                                        )}
                                    </div>

                                    {/* Phone */}
                                    <div className="col-md-6 mb-24">
                                        <label htmlFor="phone" className="text-neutral-900 text-lg mb-8 fw-medium">
                                            Phone Number <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="common-input"
                                            id="phone"
                                            placeholder="Enter Phone Number"
                                            {...formik.getFieldProps('phone')}
                                        />
                                        {formik.touched.phone && formik.errors.phone && (
                                            <div className="text-danger">{formik.errors.phone}</div>
                                        )}
                                    </div>

                                     
                                     
                                </div>

                                <div className="my-48">
                                    <p className="text-gray-500">
                                        Your personal data will be used to process your registration, support your experience throughout this website, and for other purposes described in our
                                        <Link to="#" className="text-main-600 text-decoration-underline">
                                            privacy policy
                                        </Link>
                                        .
                                    </p>
                                </div>

                                <div className="mt-48">
                                    <button type="submit" className="btn btn-main py-18 px-40">
                                        Register
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </section>
    );
};

export default Registration;
